var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPraise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.122 7.732-3.307 6.614a2.428 2.428 0 0 1-2.172 1.342H5.86V5.975h2.429l1.973-3.382a1.573 1.573 0 1 1 2.717 1.585L11.93 5.975h4.106c.903 0 1.49.95 1.086 1.757zM1 5.969h3.469v9.713H1V5.969z",
    fill: "#65B19D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPraise);
export default __webpack_public_path__ + "static/media/praise.822371025e2aa14b51877590b79234ba.svg";
export { ForwardRef as ReactComponent };